// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XeFh7GAj72zWu6 {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  display: block;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
._ewDDh1n82yV9M {
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 250px;
}
.PyKiYVVu5kJPJd {
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px) var(--ds-space-050, 4px) var(--ds-space-0, 0);
  background-color: unset;
}
.PyKiYVVu5kJPJd:hover {
  background-color: unset;
}
.w84RKY3qWiEL8K {
  margin-bottom: var(--ds-space-100, 8px);
}
.npYxstx6W6eEH3 {
  background-color: var(--ds-background-neutral, #091e420f);
  display: block;
  margin-bottom: var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-100, 3px);
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
.npYxstx6W6eEH3 a {
  color: var(--ds-link, #0c66e4);
}
.npYxstx6W6eEH3 p {
  padding: var(--ds-space-300, 24px) var(--ds-space-075, 6px);
}
.WZMjwWFlsL3zLV {
  padding-left: var(--ds-space-075, 5px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionHeader": `XeFh7GAj72zWu6`,
	"avatarList": `_ewDDh1n82yV9M`,
	"avatarContainer": `PyKiYVVu5kJPJd`,
	"textfield": `w84RKY3qWiEL8K`,
	"noResults": `npYxstx6W6eEH3`,
	"shareLink": `WZMjwWFlsL3zLV`
};
export default ___CSS_LOADER_EXPORT___;
